import axiosInstance from '$api/index';
import {ApiRoute, ConstantApiParamKey} from '$constants/api';
import store from '$redux/store';
import {PaymentDetailsResponse} from '$modules/frontdesk/Finance/PaymentDetails/types';

export async function getPaymentDetails(
  id: string
): Promise<PaymentDetailsResponse> {
  const token = store.getState().auth.token;
  try {
    const response = await axiosInstance.get(`${ApiRoute.Payments}/${id}`, {
      headers: {
        Authorization: token,
      },
    });

    return response.data;
  } catch (error: unknown) {
    const err = error as {
      response?: {data?: {message?: string; errors?: string[]}};
    };
    return {
      success: false,
      message: err?.response?.data?.message || 'Payment not found',
      errors: err?.response?.data?.errors || [],
    };
  }
}

export async function updatePaymentDescription(
  id: string,
  description: string
): Promise<PaymentDetailsResponse> {
  const token = store.getState().auth.token;
  const response = await axiosInstance.patch(
    `${ApiRoute.Payments}/${id}/update_description`,
    {
      item: {
        description,
      },
    },
    {
      headers: {
        Authorization: token,
      },
    }
  );

  return response.data;
}

export interface Discounts {
  discount_percentage: Record<string, number>;
}

export interface GetDiscountItemsResponse {
  success: boolean;
  data: Discounts;
  message: string;
}

export async function getDiscountItems(): Promise<{
  message: string;
  data: Discounts;
}> {
  const response = await axiosInstance.get<GetDiscountItemsResponse>(
    ApiRoute.Constant,
    {params: {key: ConstantApiParamKey.Discounts}}
  );

  return {
    message: response.data.message,
    data: response.data.data,
  };
}

export interface PostApplyDiscountVariables {
  discountPercentage: number;
  updatedAmount: number;
  paymentId: string;
}

export interface PostApplyDiscountResponseData {
  message: string;
  success: boolean;
  data: PaymentDetailsResponse;
}

export async function postApplyDiscount(payload: PostApplyDiscountVariables) {
  const state = store.getState();
  const token = state.auth.token;
  const {paymentId, discountPercentage, updatedAmount} = payload;

  const response = await axiosInstance.patch<PostApplyDiscountResponseData>(
    `${ApiRoute.Payments}/${paymentId}`,
    {
      payment: {
        discount_percentage: discountPercentage,
        updated_amount: updatedAmount,
      },
    },
    {
      headers: {
        Authorization: token,
      },
    }
  );

  return response.data;
}

export async function removeDiscount(paymentId: string) {
  const state = store.getState();
  const token = state.auth.token;

  const response = await axiosInstance.patch<PostApplyDiscountResponseData>(
    `${ApiRoute.Payments}/${paymentId}`,
    {
      payment: {
        discount_percentage: 0,
        updated_amount: null,
      },
    },
    {
      headers: {
        Authorization: token,
      },
    }
  );

  return response.data;
}

export const deletePaymentItem = async (
  id: string
): Promise<PaymentDetailsResponse> => {
  const token = store.getState().auth.token;
  const response = await axiosInstance.delete(
    `${ApiRoute.DeletePaymentItem}/${id}`,
    {
      headers: {
        Authorization: token,
      },
    }
  );
  return response.data;
};
